import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, FormControl, FormGroup } from 'modules/common/components';
import { AuthBox, Links } from '../styles';
import { FormWrapper, FormColumn } from 'modules/common/styles/main';
import { ControlLabel } from 'react-bootstrap';
import { Alert } from 'modules/common/utils';
import APIManager from 'modules/common/apiManager';
import { withRouter } from 'react-router';
import { localStore } from 'helpers';

const propTypes = {
  FinalSignUp: PropTypes.func.isRequired
};

class FinalSignUp extends Component {
  constructor(props) {
    super(props);

    this.mAPI = new APIManager();
    this.renderFormGroup = this.renderFormGroup.bind(this);

    this.state = {
      company_name: '',
      password: '',
      user_name: '',
      country_code: '',
      mobile_number: '',
      region_id: ''
    };
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  apiResponse(errorCode, data) {
    if (errorCode === 200) {
      Alert.success(`${data.message}`);
    } else {
      Alert.error(`${data.message}`);
    }
  }

  saveData(e) {
    let _this = this;
    let token = localStorage.getItem('token');
    console.log('Token', token);
    e.preventDefault();
    let tData = {
      company_name: this.state.company_name,
      password: this.state.password,
      user_name: this.state.user_name,
      country_code: this.state.country_code,
      mobile_number: this.state.mobile_number,
      region_id: this.state.region_id
    };
    let header = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
    // this.mAPI.sendPostAPI(
    //   `signup`,
    //   tData,
    //   data => {
    //     console.log(JSON.stringify(data, null, 2));
    //     // Alert.success(`SignUp Successfully.`);
    //     localStorage.removeItem('email');
    //     window.location.href = '/sign-in';
    //   },
    //   (errorCode, data) => {
    //     this.apiResponse(errorCode, data);
    //   },
    //   `public`,
    //   header,
    //   'PUT'
    // );
  }

  render() {
    const { __ } = this.context;
    return (
      <AuthBox>
        <div>
          <h2 style={{ marginBottom: '20px' }}>{__('Sign Up')}</h2>
          <form onSubmit={e => this.saveData(e)}>
            <FormWrapper>
              {/* <FormColumn></FormColumn> */}
              <FormColumn>
                {this.renderFormGroup('Company Name', {
                  defaultValue: '',
                  placeholder: '',
                  autoFocus: true,
                  required: true,
                  id: 'company_name',
                  value: this.state.company_name,
                  onChange: e => {
                    this.setState({ company_name: e.target.value });
                  }
                })}
              </FormColumn>
            </FormWrapper>
            <FormWrapper>
              <FormColumn>
                {this.renderFormGroup('Password', {
                  defaultValue: '',
                  autoFocus: true,
                  required: true,
                  type: 'password',
                  value: this.state.password,
                  onChange: e => {
                    this.setState({ password: e.target.value });
                  },
                  id: 'password'
                })}
              </FormColumn>
            </FormWrapper>
            <FormWrapper>
              <FormColumn>
                {this.renderFormGroup('User Name', {
                  defaultValue: '',
                  autoFocus: true,
                  required: true,
                  type: 'user_name',
                  value: this.state.user_name,
                  onChange: e => {
                    this.setState({ user_name: e.target.value });
                  },
                  id: 'user_name'
                })}
              </FormColumn>
            </FormWrapper>
            <FormWrapper>
              <FormColumn>
                {this.renderFormGroup('Country Code', {
                  defaultValue: '',
                  autoFocus: true,
                  required: true,
                  type: 'country_code',
                  value: this.state.country_code,
                  onChange: e => {
                    this.setState({ country_code: e.target.value });
                  },
                  id: 'country_code'
                })}
              </FormColumn>
              <FormColumn>
                {this.renderFormGroup('Mobile Number', {
                  defaultValue: '',
                  autoFocus: true,
                  required: true,
                  type: 'mobile_number',
                  value: this.state.mobile_number,
                  onChange: e => {
                    this.setState({ mobile_number: e.target.value });
                  },
                  id: 'mobile_number'
                })}
              </FormColumn>
            </FormWrapper>
            <FormWrapper>
              <FormColumn>
                {this.renderFormGroup('Region Id', {
                  defaultValue: '',
                  autoFocus: true,
                  required: true,
                  type: 'region_id',
                  value: this.state.region_id,
                  onChange: e => {
                    this.setState({ region_id: e.target.value });
                  },
                  id: 'region_id'
                })}
              </FormColumn>
            </FormWrapper>
            <div>
              <Button
                btnStyle="default"
                type="submit"
                block
                style={{ marginTop: '30px' }}
              >
                SIGN UP
              </Button>
              {/* <Links style={{ marginTop: '-12px', textAlign: 'end' }}>
              <Link to="/otp">{__('Comfirm Email')}</Link>
            </Links> */}
              <Links style={{ marginTop: '15px', textAlign: 'center' }}>
                Already have an account ?{' '}
                <Link to="/sign-in">{__('Login here')}</Link>
              </Links>
            </div>
          </form>
        </div>
      </AuthBox>
    );
  }
}

FinalSignUp.propTypes = propTypes;
FinalSignUp.contextTypes = {
  __: PropTypes.func
};

export default withRouter(FinalSignUp);



// WEBPACK FOOTER //
// ./src/modules/auth/components/FinalSignUp.js